import React from 'react'
import { render } from 'react-dom'
import isEmpty from 'lodash/isEmpty'

import { ElementDatasetConfig } from '../../services/config/ElementConfigService'

interface windowWithJQuery extends Window {
	$?: any,
  addEventAsync: (dataLayerEventName: string, applicationID: string) => void
}

declare const window: windowWithJQuery
const $ = window.$

export const FORM_WIDGET_COMPONENT_NAME = 'formruntime'
export const FORM_WIDGET_ELEMENT_SELECTOR = `[data-component="${FORM_WIDGET_COMPONENT_NAME}"]`

document.querySelectorAll(FORM_WIDGET_ELEMENT_SELECTOR)
  .forEach(function (element) {
    import('schemaform/src/formruntime').then(async ({ default: FormRuntime }) => {

      const config = ElementDatasetConfig(element)
      const {
        applicationId,
        courseId,
        applicationStatusId,
        formSaveUrl,
        formValidateUrl,
        formSaveRedirectUrl = '',
        saveButtonLabel,
        formDataUrl,
        lookupsUrl,
        fileUploadUrl,
        unitPickerUrl,
        googleMapsKey,
        environment,
        singlePageMode,
        canSubmit,
        readOnly,
        preview,
        theme,
        allowedFileMimetype="",
        allowedFileType="",
      } = config

      function disableActionButtons () {
        document.querySelector('div.SchemaForm-runtimeform__actions')?.remove()
      }

      // Note: Schemaform does disable save and submit buttons while promise is executing
      // However for admit we then navigate by document.location, so we also want to disable here too while browser is redirecting
      function saveForm(formData, doSubmit, submittedWithErrors = false) {
        return $.post({
          url: formSaveUrl,
          data: { formData: JSON.stringify(formData) }
        })
          .done(function (res) {
            $.notify('Saved!', 'success');
            if (!doSubmit) {
              // Run DataLayer events - Don't ask AD-4303
              if (typeof window.addEventAsync === 'function') {
                window.addEventAsync('application-save', applicationId)
                window.addEventAsync('application-edit', applicationId)
              }
            }
            if (formValidateUrl) {
              if (doSubmit) {
                if (!submittedWithErrors) {
                  disableActionButtons()
                  /* proceed to the validation page, does not happen for preview when the url is empty */
                  document.location = formValidateUrl
                }
              }
            }
            // Use save redirect url if available
            if (!doSubmit && formSaveRedirectUrl != '') {
              if (!submittedWithErrors) {
                disableActionButtons()
                document.location = formSaveRedirectUrl
              }
            }
          })
          .fail(function (res) {
            $.notify('Save failed!', 'error');
          })
      }

      // always disable for now
      const disableAutoSave = true

      function autoSaveForm(formData) {
        return $.post({
          url: formSaveUrl,
          data: { formData: JSON.stringify(formData) }
        })
      }

      const {
        formDefinition = {},
        formData = {},
      } = await FetchData(formDataUrl)

      const formLookups = await FetchData(lookupsUrl)

      const baseURL = ''
      const formConfig = {
        api: {
          baseURL
        },
        LOOKUPS: formLookups,
        FILE_UPLOAD_URL: fileUploadUrl,
        UNIT_PICKER_URL: unitPickerUrl,
        SERVICES: {
          'GOOGLEMAPS_APIKEY': googleMapsKey,
        },
        META: {
          applicationId: applicationId,
          courseId: courseId,
          applicationStatusId: `${applicationStatusId}`,
        },
        ALLOWED_FILE_MIMETYPE : allowedFileMimetype.split(","),
        ALLOWED_FILE_TYPE : allowedFileType.split(","),
      }

      const hasNoFormDefinition = isEmpty(formDefinition)

      const handleSave = ({ formData, errors, isSubmitting }) => {
        // if isSubmitting === true, it means that user clicked submit button, however there were errors
        // schemaform fires the save handler so that user entered data can still be saved
        if (isSubmitting) {
          return saveForm(formData, false, true)
        } else {
          return saveForm(formData, false)
        }
      }

      const handleError = ({ formData, errors }) => {
        if (errors) {
          $.notify('There are still ' + Object.keys(errors).length + ' errors to fix', 'error');
        } else {
          $.notify('Validated!', 'success');
        }
      }

      const handleOnChange = (schemas) =>{
        if (readOnly || preview || disableAutoSave) {
          return
        }
        const {formData = {}} = schemas
        autoSaveForm(formData)
      }

      const handleSubmit = ({ formData }) => {
        return saveForm(formData, true)
      }

      const instance = (
        hasNoFormDefinition
          ? <React.Fragment />
          : (
            <FormRuntime
              {...formDefinition}
              formData={formData}
              environment={environment}
              singlePageMode={singlePageMode}
              preview={preview}
              canSubmit={canSubmit}
              saveLabel={saveButtonLabel || 'Save'}
              readOnly={readOnly}
              config={formConfig}
              onSave={handleSave}
              onError={handleError}
              onSubmit={handleSubmit}
              onChange={handleOnChange}
              theme={theme}
            />
          )
      )
      render(instance, element.parentElement)
    })
  })

function FetchData(url) {
  return fetch(url)
    .then(function (response) {
      if (response.status !== 200) {
        console.log(`Looks like there was a problem. Status Code: ${response.status}`)
        return
      }
      return response.json()
    })
}
